
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseReturnItemsBOMGrid extends Serenity.EntityGrid<PurchaseReturnItemsBOMRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseReturnItemsBOM'; }
        protected getDialogType() { return PurchaseReturnItemsBOMDialog; }
        protected getIdProperty() { return PurchaseReturnItemsBOMRow.idProperty; }
        protected getInsertPermission() { return PurchaseReturnItemsBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseReturnItemsBOMRow.localTextPrefix; }
        protected getService() { return PurchaseReturnItemsBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}